/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { updateBranches } from '../../../../apis/companies/branches';
import { ControlTable } from '../../../../components/Table';
import { getParamsOld } from '../../../../utils/params';
import systemAlert from '../../../../utils/systemAlert';

// 0 지점 1 본점 9 요청
const HeadBranchTable = (props) => {
  const { title, tableType, setOpen, setType, api, permission } = props;
  const [fields, setFields] = useState();
  const [list, setList] = useState([])
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    switch (tableType) {
      case 9:
        setFields([
          { title: "회사명", key: "branchCompany.name" },
          { title: "사업자번호", key: "branchCompany.comNum" },
          { title: "종사업자번호", key: "branchCompany.sectNum" },
          {
            isHide: permission.level <= 1,
            type: 'button',
            size: 'x-sm',
            color: 'green',
            label: '등록',
            style: {
              width: '80px'
            },
            onClick: ({ data }) => {
              confirmReqeust(data, 1)
            }
          },
          {
            isHide: permission.level <= 1,
            type: 'button',
            size: 'x-sm',
            color: 'red',
            label: '반려',
            style: {
              width: '80px'
            },
            onClick: ({ data }) => {
              confirmReqeust(data, 0)
            }
          }
        ])
        break;
      default:
        setFields([
          { title: "회사명", key: "branchCompany.name" },
          { title: "사업자번호", key: "branchCompany.comNum" },
          { title: "종사업자번호", key: "branchCompany.sectNum" },
        ])
        break;
    }
  }, [])

  const confirmReqeust = (data, state) => {
    const { branchCompany, idx } = data

    systemAlert(
      `${branchCompany.name}을(를) ${state === 1 ? '등록' : '반려'}하시겠습니까?`,
      {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: `${state === 1 ? '등록' : '반려'}`,
            onClick: () => {
              updateBranches(idx, { state }).then(() => { submit() })
            }
          }
        ]
      }
    )
  }

  useEffect(() => { submit() }, [page, limit])

  const submit = () => {
    setIsLoading(true)
    api({ ...getParamsOld({ page, limit }), type: tableType }).then((res) => {
      setList(res.data.branches)
      setTotal(res.data.total)
    }).catch(() => { }).finally(() => { setIsLoading(false) })
  }

  const getHeaderButtons = () => {
    let buttons = []
    switch (tableType) {
      case 0:
        buttons = [
          {
            label: "지점 추가",
            action: () => {
              setOpen(true)
              setType(0)
            },
          },
        ]
        break;
      case 1:
        buttons = [
          {
            label: "본점 추가",
            action: () => {
              setOpen(true)
              setType(1)
            },
          },
        ]
        break;
      case 9:
        break;
      default:
        break;
    }

    return buttons
  }

  return (
    <>
      <ControlTable
        isLoading={isLoading}
        fields={fields}
        list={list}
        title={title}
        buttons={permission.level > 1 ? getHeaderButtons() : []}
        total={total}
        page={page}
        setPage={setPage}
        limit={limit}
        setLimit={setLimit}
      />
    </>
  )
}

export default HeadBranchTable